import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Plus, TrendingUp, Image, FolderOpen } from 'lucide-react';

export default function Dashboard({ stats, onRefresh }) {
  return (
    <div className="space-y-6" data-testid="dashboard">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 mb-1">Total Projects</p>
              <p className="text-3xl font-bold" style={{ color: '#b8d71b' }}>{stats.total_projects}</p>
            </div>
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: '#b8d71b20' }}>
              <FolderOpen size={24} style={{ color: '#b8d71b' }} />
            </div>
          </div>
        </Card>

        <Card className="p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 mb-1">Total Images</p>
              <p className="text-3xl font-bold" style={{ color: '#b8d71b' }}>{stats.total_images}</p>
            </div>
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: '#b8d71b20' }}>
              <Image size={24} style={{ color: '#b8d71b' }} />
            </div>
          </div>
        </Card>

        <Card className="p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 mb-1">Categories</p>
              <p className="text-3xl font-bold" style={{ color: '#b8d71b' }}>{stats.total_categories}</p>
            </div>
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: '#b8d71b20' }}>
              <TrendingUp size={24} style={{ color: '#b8d71b' }} />
            </div>
          </div>
        </Card>
      </div>

      {/* Quick Actions */}
      <Card className="p-6">
        <h2 className="text-xl font-bold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Button className="h-20 btn-hover" style={{ background: '#b8d71b', color: '#1a1a1a' }} data-testid="quick-add-project">
            <Plus size={20} className="mr-2" />
            New Project
          </Button>
          <Button className="h-20 btn-hover" variant="outline" data-testid="quick-add-category">
            <Plus size={20} className="mr-2" />
            New Category
          </Button>
          <Button className="h-20 btn-hover" variant="outline" data-testid="quick-upload-image">
            <Image size={20} className="mr-2" />
            Upload Images
          </Button>
        </div>
      </Card>

      {/* Welcome Section */}
      <Card className="p-8 bg-gradient-to-br from-gray-50 to-white">
        <h2 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Welcome to Your Portfolio Admin</h2>
        <p className="text-gray-600 mb-6">
          Manage your architecture projects, organize your media library, and control every aspect of your portfolio with ease.
        </p>
        <div className="space-y-2 text-sm text-gray-600">
          <p><strong>Getting Started:</strong></p>
          <ol className="list-decimal list-inside space-y-1 ml-4">
            <li>Create categories for your projects (Residential, Commercial, etc.)</li>
            <li>Add your first project with title, description, and category</li>
            <li>Upload up to 10 high-quality images per project</li>
            <li>Update contact information in Settings</li>
            <li>View your live portfolio on the homepage</li>
          </ol>
        </div>
        <Button onClick={onRefresh} variant="outline" className="mt-6" data-testid="refresh-stats-btn">Refresh Stats</Button>
      </Card>
    </div>
  );
}